var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"teacher-img-link",attrs:{"to":{name: 'teacherPage', params:{tid: this.teacher.id}}}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":_vm.teacher.name,"title":_vm.teacher.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }